<template>
  <!-- <v-container fill-height fluid> -->
  <v-layout justify-center column>
    <section
      id="aboutSectionHeader"
      style="position:relative;min-width:100vw;height:500px"
    >
      <v-img
        height="100%"
        position="center center"
        :src="require('../assets/Headers/impact business-03.jpg')"
        class="hidden-xs-only"
      />
      <v-img
        height="300"
        position="center center"
        :src="require('../assets/Headers/impact business-03.jpg')"
        class="hidden-sm-and-up"
      />
    </section>

    <v-container class="pageContent">
      <v-layout column>
        <v-layout row wrap justify-space-around align-start>
          <v-flex xs12 style="text-align: center">
            <h1
              style="font-weight: bold !important;font-family: 'Aleo' !important;font-size: 30pt !important;color: black;"
            >
              UpstreamNZ Impact Reports
            </h1>
          </v-flex>
          <v-flex xs12 style="text-align: left;">
            <p>
              Our aim is to strengthen the wellbeing of children and young
              people in New Zealand. Your business can become a massive impact
              maker, simply through the procurement of your business and
              empowering your staff to get behind your mission. We have to
              improve the statistics surrounding our young people in New
              Zealand, your business has the power to change that
            </p>
            <br />
          </v-flex>
        </v-layout>
      </v-layout>
      <v-sheet
        class="pa-2"
        style="border:2px solid #4dc8ed;-webkit-border-radius: 5px;-moz-border-radius: 5px;border-radius: 5px;"
      >
        <div
          class="headline"
          style="font-weight: bold !important; font-family: 'Aleo' !important; color: #4cc7e8;"
        >
          Search by: Business Name
        </div>
        <v-layout row>
          <!--            <v-flex xs12 sm6 class="pa-2">-->
          <!--              <v-select-->
          <!--                v-model="filter.category"-->
          <!--                :items="categories"-->
          <!--                item-text="name"-->
          <!--                item-value="name"-->
          <!--                label="Category"-->
          <!--                placeholder="Please select"-->
          <!--                clearable-->
          <!--                @change="filterList()"-->
          <!--              />-->
          <!--            </v-flex>-->
          <v-flex xs12 class="pa-2">
            <v-text-field v-model="filter" @keyup="filterList()"></v-text-field>
          </v-flex>
        </v-layout>
      </v-sheet>
      <v-layout style="padding: 15px 0px;" row wrap align-center>
        <v-flex xs12>
          <div style="color: #4cc7e8; text-align: center;" class="title">
            Want to become an Impact Business -
            <span
              style="cursor: pointer; text-decoration: underline;"
              @click="$router.push('/ImpactBusinessJoin')"
              >Click Here</span
            >
          </div>
        </v-flex>
      </v-layout>
      <v-progress-linear v-if="loadingResults" :indeterminate="true" />
      <div
        v-if="businesses.length === 0"
        class="subheading font-weight-thin mt-3"
      >
        No results found
      </div>
      <v-layout v-if="false" row wrap align-center>
        <v-flex v-for="business in activeBusinesses" :key="business.id" xs12>
          <v-layout row class="elevation-1 pa-2">
            <v-flex xs2>
              <v-img
                v-if="business.imageUrl"
                :src="business.imageUrl"
                :width="150"
                :height="100"
                class="autoMargin"
              />
              <v-img
                v-else
                src="./img/upstream-logo-compact.png"
                :width="150"
                :height="150"
                contain
              />
            </v-flex>
            <v-flex xs8>
              <v-layout column justify-center fill-height>
                <div class="title">{{ business.company }}</div>
                <div class="subheading">{{ business.description }}</div>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-container grid-list-xl class="pageContent">
        <v-layout row wrap align-center>
          <v-flex
            v-for="business in businesses"
            :key="business.id"
            xs12
            sm6
            md4
            id="businessListingsSearch"
            class="businessListingsSearchHeight"
            style="height:420px;"
          >
            <v-card
              @click="loadBusiness(business.id)"
              class="elevation-2"
              style="height: 100%;"
            >
              <v-layout row>
                <v-flex xs2>
                  <v-icon style="margin-left: 10px;font-size: 35pt; color: red;"
                    >mdi-charity</v-icon
                  >
                </v-flex>
                <v-flex xs10>
                  <div class="subheading">
                    ${{ business.totalContributions }}
                  </div>
                  <div class="subheading">
                    {{ Math.round(business.totalContributions * 0.0567) }}
                    hrs
                  </div>
                </v-flex>
              </v-layout>
              <v-img v-if="business.imageUrl" :src="business.imageUrl" />
              <v-img
                v-else
                src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/upstream-logo-padded.png?alt=media&token=748dcd0a-a617-4173-b33b-57aed67c4bc6"
                height="300px"
              />
              <v-card-title>
                <div>
                  <div class="title aboutWorkersName">
                    {{ business.company }}
                  </div>
                  <span class="aboutWorkersTitle">
                    {{ business.description }}
                  </span>
                </div>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
  </v-layout>
  <!-- </v-container> -->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    loadingResults: true,
    filter: "",
  }),
  computed: {
    ...mapGetters({
      user: "user",
      businesses: "impactBusinesses/filteredList",
    }),
  },
  created() {
    this.$nextTick(function() {
      this.filterList();
    });
  },
  methods: {
    loadBusiness(businessId) {
      this.$store.dispatch("impactBusinesses/loadProfile", businessId);
      this.$router.push(`/impactBusinessProfile/${businessId}`);
    },
    filterList(d) {
      this.loadingResults = true;
      this.$store.dispatch("impactBusinesses/filter", this.filter).then(() => {
        this.loadingResults = false;
      });
    },
  },
};
</script>

<style scoped>
.aboutWorkersName {
  font-weight: bold !important;
  font-family: "Aleo" !important;
  font-size: 15pt !important;
  color: #4cc7e8;
  margin-bottom: 0 !important;
}

.aboutWorkersTitle {
  font-weight: bold !important;
  font-family: "Aleo" !important;
  font-size: 12pt !important;
  color: #5a5a5c;
}

@media screen and (max-width: 1700px) {
  .businessListingsSearchHeight {
    height: 430px !important;
  }
}

@media screen and (max-width: 1264px) {
  .businessListingsSearchHeight {
    height: 380px !important;
  }
}

@media screen and (max-width: 960px) {
  .businessListingsSearchHeight {
    height: 500px !important;
  }
}

@media screen and (max-width: 870px) {
  .businessListingsSearchHeight {
    height: 460px !important;
  }
}

@media screen and (max-width: 600px) {
  .businessListingsSearchHeight {
    height: auto !important;
  }
}

@media only screen and (max-width: 960px) {
  /* #businessListingsSearch {
                                                                                                                                                                                                                                                                    height: 450px !important;
                                                                                                                                                                                                                                                                  } */
}

@media only screen and (max-width: 600px) {
  section#aboutSectionHeader {
    height: 100% !important;
  }
}

@media only screen and (min-width: 1904px) {
  .pageContent {
    max-width: 1200px;
  }
}
</style>
